import { SliceType } from "./sliceType";

export class Slice {
  sliceType: SliceType;
  span: number;
  constructor(sliceType: SliceType, span: number) {
    this.sliceType = sliceType;
    this.span = span;
  }
}



// WEBPACK FOOTER //
// ./src/app/models/slice.ts